import { render, staticRenderFns } from "./SvgLogo.vue?vue&type=template&id=2cef6987"
import script from "./SvgLogo.vue?vue&type=script&lang=js"
export * from "./SvgLogo.vue?vue&type=script&lang=js"
import style0 from "./SvgLogo.vue?vue&type=style&index=0&id=2cef6987&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports